import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';

import PageDietsList from 'components/pages/professional/programs/diets/list/page-diets-list';
import ButtonCreateNewDiet from 'components/pages/professional/programs/diets/list/cmpt-button-create-new-diet';

import PageDietMainInformation from 'components/pages/professional/programs/diets/details/main-information/page-diet-main-information';
import PageDietBasicInformation from 'components/pages/professional/programs/diets/details/main-information/page-diet-basic-information';
// import PageDietPayment from 'components/pages/professional/programs/diets/details/main-information/page-diet-payment';
// import PageDietHealthRelatedSemantic from 'components/pages/professional/programs/diets/details/main-information/page-diet-health-related-semantic';
// import PageDietCategorisation from 'components/pages/professional/programs/diets/details/main-information/page-diet-categorisation';

import PageSearchPrograms from 'components/pages/professional/programs/shared/search-east/page-search-programs';

import PageCreateCopyProgram from 'components/pages/professional/programs/shared/make-copy/page-create-copy-program';
import PageCreateDietBasicInformation from 'components/pages/professional/programs/diets/details/create-diet/page-create-diet-basic-information';

import PageDietSchedules from 'components/pages/professional/programs/diets/details/shedules/page-diet-schedules';
import PageOptionsAddScheduleToDiet from 'components/pages/professional/programs/shared/schedules/cred/page-options-add-schedule-to-diet';

import PageSearchStuffToEat from 'components/pages/professional/stuff-to-eat/shared/search-east/page-search-stuff-to-eat';

import LayoutSetDietDetails from 'components/ui/layout-set/programs/layout-set-diet-details';
import MenuCollapsedTopDietDetails from 'components/pages/professional/programs/diets/details/shared/cmpt-menu-collapsed-top-diet-details';

import PageAddStuffToEatSimpleSchedule from 'components/pages/professional/programs/shared/schedules/cred/page-add-stuff-to-eat-simple-schedule';
import PageEditStuffToEatSimpleSchedule from 'components/pages/professional/programs/shared/schedules/cred/page-edit-stuff-to-eat-simple-schedule';

import PageAddStuffToEatComplexSchedule from 'components/pages/professional/programs/shared/schedules/cred/page-add-stuff-to-eat-complex-schedule';
import PageEditStuffToEatComplexSchedule from 'components/pages/professional/programs/shared/schedules/cred/page-edit-stuff-to-eat-complex-schedule';

import PageProgramCoverImage from 'components/pages/professional/programs/shared/cover-image/page-program-cover-image';

import PageManageDietDays from 'components/pages/professional/programs/shared/schedules/manage/page-manage-diet-days';
import PageCopyDietDay from 'components/pages/professional/programs/shared/schedules/manage/page-copy-diet-day';

import PageDietDailyGoals from 'components/pages/professional/programs/diets/details/daily_goals/page-diet-daily-goals';
import PageDietColaboration from 'components/pages/professional/programs/diets/details/colaboration/page-diet-colaboration';

// import PageProgramSettings from 'components/pages/professional/shared/page/virtual-page';
import PageProgramChangeStatus from 'components/pages/professional/programs/shared/settings/status/page-program-change-status';
import PageProgramDelete from 'components/pages/professional/programs/shared/settings/delete/page-program-delete';

import { STUFF_TO_EAT_KEYS, PROGRAMS_KEYS } from 'constants/types';

const type = PROGRAMS_KEYS.diet;

export default [
  {
    path: '/professional/programs/diets',
    component: LayoutSetLevelZero,
    props: {
      index: true,
    },
    children: [
      {
        path: '',
        name: 'diets-list',
        components: {
          default: PageDietsList,
          collapsedMenuTop: ButtonCreateNewDiet,
        },
        meta: {
          auth: true,
        },
        props: {
          default: route => ({
            page: Number(route.query.page),
            meta: {
              navigation: {
                edit: 'diet-basic-information',
                status: 'diet-settings-status',
              },
            },
          }),
          collapsedMenuTop: {
            type,
            title: 'label.create_new_diet',
            link: 'diet-search-programs',
          },
        },
        children: [
          {
            path: 'search',
            name: 'diet-search-programs',
            component: PageSearchPrograms,
            meta: {
              auth: true,
            },
            props: {
              meta: {
                title: 'label.use_template',
                navigation: {
                  cancel: 'diets-list',
                  itemClickNavigation: 'create-diet-copy',
                  itemNew: {
                    label: 'label.create_new_program',
                    name: 'create-diet-basic-information',
                  },
                },
              },
            },
            children: [
              {
                path: 'create-copy/:programType/:programID(\\d+)',
                name: 'create-diet-copy',
                component: PageCreateCopyProgram,
                meta: { auth: true },
                props: route => ({
                  id: route.params.programID,
                  type: route.params.programType,
                  meta: {
                    title: 'label.create_new_program',
                    navigation: {
                      back: 'diet-search-programs',
                      cancel: 'diets-list',
                      success: 'diet-basic-information',
                    },
                  },
                }),
              },
              {
                path: 'create-new',
                name: 'create-diet-basic-information',
                component: PageCreateDietBasicInformation,
                meta: {
                  auth: true,
                },
                props: {
                  meta: {
                    title: 'label.create_new_program',
                    navigation: {
                      back: 'diet-search-programs',
                      cancel: 'diets-list',
                      success: 'diet-basic-information',
                    },
                  },
                },
              },
            ],
          }, // end ~ search
        ],
      },
    ],
  }, // end ~ path: '/programs/diets',
  {
    path: '/professional/programs/diets/:id(\\d+)',
    component: LayoutSetDietDetails,
    props: route => ({
      id: route.params.id,
      meta: {
        navigation: {
          index: 'diets-list',
          status: 'diet-settings-status',
        },
      },
    }),
    children: [
      {
        path: 'main-information',
        components: {
          default: PageDietMainInformation,
          collapsedMenuTop: MenuCollapsedTopDietDetails,
        },
        props: {
          default: true,
          collapsedMenuTop: true,
        },
        // component: PageDietMainInformation,
        children: [
          {
            path: 'basic',
            name: 'diet-basic-information',
            component: PageDietBasicInformation,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.main_information',
                section: 'label.diet_details',
                navigation: {
                  index: 'diets-list',
                },
              },
            }),
          },
          // {
          //   path: 'payment',
          //   name: 'diet-payment',
          //   component: PageDietPayment,
          //   props: true,
          // },
          {
            path: 'cover-image',
            name: 'diet-cover-image',
            component: PageProgramCoverImage,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.program_cover',
                section: 'label.diet_details',
                navigation: {
                  index: 'diets-list',
                },
              },
            }),
          },
          // {
          //   path: 'health-related-semantic',
          //   name: 'diet-health-related-semantic',
          //   component: PageDietHealthRelatedSemantic,
          //   props: true,
          // },
          {
            path: 'schedules/:dayID(\\d+)',
            name: 'diet-schedules',
            components: {
              default: PageDietSchedules,
              collapsedMenuTop: MenuCollapsedTopDietDetails,
            },
            props: {
              default: route => ({
                id: route.params.id,
                dayID: route.params.dayID,
                cancelNavigation: 'diet-schedules',
                meta: {
                  title: 'label.schedules',
                  section: 'label.diet_details',
                  navigation: {
                    editSimple: 'diet-schedule-edit-simple-stuff-to-eat',
                    editComplex: 'diet-schedule-edit-complex-stuff-to-eat',
                  },
                },
              }),
              collapsedMenuTop: route => ({
                dayID: route.params.dayID,
              }),
            },
            children: [
              {
                path: 'add-schedule',
                name: 'options-add-schedule-to-diet',
                component: PageOptionsAddScheduleToDiet,
                props: {
                  meta: {
                    navigation: {
                      cancel: 'diet-schedules',
                      search: 'diet-schedule-search-stuff-to-eat',
                    },
                  },
                },
                children: [
                  {
                    path: 'search/:itemParamName/:itemClickNavigation/:entityType',
                    name: 'diet-schedule-search-stuff-to-eat',
                    component: PageSearchStuffToEat,
                    props: route => ({
                      entityType: route.params.entityType,
                      meta: {
                        navigation: {
                          cancel: 'diet-schedules',
                          back: 'options-add-schedule-to-diet',
                          itemParamName: route.params.itemParamName,
                          itemClickNavigation: route.params.itemClickNavigation,
                        },
                      },
                    }),
                    children: [
                      {
                        path: 'stuff-to-eat-simple/:entityID(\\d+)',
                        name: 'diet-schedule-add-stuff-to-eat-simple',
                        component: PageAddStuffToEatSimpleSchedule,
                        props: route => ({
                          id: route.params.id,
                          dayID: route.params.dayID,
                          entityID: route.params.entityID,
                          entityType: route.params.entityType,
                          meta: {
                            title: 'label.add_schedule',
                            navigation: {
                              cancel: 'diet-schedules',
                              back: 'diet-schedule-search-stuff-to-eat',
                              success: 'diet-schedule-search-stuff-to-eat',
                            },
                          },
                        }),
                      },
                      {
                        path: 'stuff-to-eat-complex/:entityID(\\d+)',
                        name: 'diet-schedule-add-stuff-to-eat-complex',
                        component: PageAddStuffToEatComplexSchedule,
                        props: route => ({
                          id: route.params.id,
                          dayID: route.params.dayID,
                          entityID: route.params.entityID,
                          entityType: route.params.entityType,
                          meta: {
                            title: 'label.add_schedule',
                            navigation: {
                              cancel: 'diet-schedules',
                              back: 'diet-schedule-search-stuff-to-eat',
                              success: 'diet-schedule-search-stuff-to-eat',
                            },
                          },
                        }),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'edit-stuff-to-eat-simple-schedule/:entityType/:entityID(\\d+)/:scheduleID(\\d+)',
                name: 'diet-schedule-edit-simple-stuff-to-eat',
                component: PageEditStuffToEatSimpleSchedule,
                props: route => ({
                  id: route.params.id,
                  dayID: route.params.dayID,
                  entityID: route.params.entityID,
                  entityType: route.params.entityType,
                  scheduleID: route.params.scheduleID,
                  meta: {
                    title: 'label.edit_schedule',
                    navigation: {
                      cancel: 'diet-schedules',
                      success: 'diet-schedules',
                    },
                  },
                }),
              },
              {
                path: 'edit-stuff-to-eat-complex-schedule/:entityType/:entityID(\\d+)/:scheduleID(\\d+)',
                name: 'diet-schedule-edit-complex-stuff-to-eat',
                component: PageEditStuffToEatComplexSchedule,
                props: route => ({
                  id: route.params.id,
                  dayID: route.params.dayID,
                  entityID: route.params.entityID,
                  scheduleID: route.params.scheduleID,
                  entityType: STUFF_TO_EAT_KEYS.meal,
                  meta: {
                    title: 'label.edit_schedule',
                    navigation: {
                      cancel: 'diet-schedules',
                      success: 'diet-schedules',
                    },
                  },
                }),
              },
              {
                path: 'manage-diet-days',
                name: 'manage-diet-days',
                component: PageManageDietDays,
                props: route => ({
                  id: route.params.id,
                  dayID: route.params.dayID,
                  meta: {
                    navigation: {
                      cancel: 'diet-schedules',
                      success: 'diet-schedules',
                    },
                  },
                }),
              },
              {
                path: 'copy-diet-day',
                name: 'copy-diet-day',
                component: PageCopyDietDay,
                props: route => ({
                  id: route.params.id,
                  dayID: route.params.dayID,
                  meta: {
                    navigation: {
                      cancel: 'diet-schedules',
                      success: 'diet-schedules',
                    },
                  },
                }),
              },
            ],
          },
        ],
      },
      {
        props: true,
        path: 'settings',
        component: PageDietMainInformation,
        children: [
          {
            path: 'status',
            name: 'diet-settings-status',
            component: PageProgramChangeStatus,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                title: 'label.status',
                section: 'label.settings',
                navigation: {
                  index: 'diets-list',
                },
              },
            }),
          },
          {
            path: 'delete',
            name: 'diet-settings-delete',
            component: PageProgramDelete,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                title: 'label.delete_program',
                section: 'label.settings',
                navigation: {
                  index: 'diets-list',
                  success: 'diets-list',
                },
              },
            }),
          },
        ],
      },
      {
        path: 'daily-goals',
        name: 'diet-daily-goals',
        component: PageDietDailyGoals,
        props: true,
      },
      {
        path: 'colaboration',
        name: 'diet-colaboration',
        component: PageDietColaboration,
        props: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/programs/router-diets.js